import styled from '@emotion/styled';
import { colors } from '@smartsheet/lodestar-core';

export const Bar = styled.div`
  background: ${colors.neutralLight40};
  box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  width: 48px;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 5;
  position: relative;
`;
